<template>
	<div class="warehouse-product-settings">
		<AppTable ref="transfers-table"
				  :fetch-function="getFilteredLogsWarehouseProduct"
				  :filters="filters"
				  :table-headings="tableHeadings"
				  :title="getString('product_logs', [product.name])"
				  :total-items="logsTotal || 0"
				  :items="logs || []"
				  initial-sort-field="date"  />
	</div>
</template>

<script>
import ModalHeader from "@/console-new/components/shared/ModalHeader.vue";
import {useLanguageStore, useNotificationStore} from "@/shared/stores";
import {useUserStore} from "@/console-new/stores";
import API from "@/shared/helpers/API";
import AppTable from "@/shared/components/AppTable.vue";
import {getLocalDateFromServer} from "@/shared/helpers/dates";

export default {
	setup() {
		const languageStore = useLanguageStore();
		const userStore = useUserStore();
		const notificationStore = useNotificationStore();
		return {
			getString: languageStore.getString,
			userStore,
			notificationStore
		}
	},
	name: "WarehouseProductLogs",
	components: {ModalHeader, AppTable},
	emits: ['exit'],
	props: {
		product: {
			type: Object,
			required: true,
		},
	},
	data() {
		return {
			filters: [
				{
					type: "date",
					key: 'date',
					tableName: 'menu_items_warehouse_logs',
					text: this.getString('date'),
					finalValue: '',
					active: false
				},
				{
					type: "quantity",
					key: "stock",
					text: this.getString('new_stock'),
					active: false,
					value: null,
					activeItem: 0,
					finalValue: '',
				},
				{
					type: "quantity",
					key: "variation",
					text: this.getString('variation'),
					active: false,
					value: null,
					activeItem: 0,
					finalValue: '',
				},
				{
					type: "checklist",
					key: "type",
					text: this.getString('type'),
					values: [this.getString('order'),this.getString('user_adjust'),this.getString('supplier_order')],
					keysArray: ["order","user_adjust","supplier_order"],
					active: false,
					selectedIndexes: [],
					finalValue: '',
				},
			],
			tableHeadings: [
				{
					text: this.getString('date'),
					cols: 1,
					sortable: true,
					fieldName: 'date',
				},
				{
					text: this.getString('new_stock'),
					cols: 1,
					fieldName: 'stock',
				},
				{
					text: this.getString('variation'),
					cols: 1,
					fieldName: 'variation',
				},
				{
					text: this.getString('type'),
					cols: 1,
					fieldName: 'type_string',
				},
				{
					text: this.getString('user'),
					cols: 1,
					fieldName: 'user_name',
				},
				{
					text: this.getString('order_number'),
					cols: 1,
					fieldName: 'order_number',
				},
			],
			logsTotal: 0,
			logs: [],
		}
	},
	methods: {
		getFilteredLogsWarehouseProduct(filters, callback = null) {

			if(!this.userStore.currBusinessId) {
				if(callback) { callback(false); }
				return;
			}

			API.init().getFilteredLogsWarehouseProduct(this.userStore.currBusinessId, this.product.menu_item_warehouse_id, JSON.stringify(filters || []), r=> {
				this.logs = [];
				this.logsTotal = 0;
				if(r && r.result === "OK") {
					if(r.logs && r.logs.selected && r.logs.selected.length) {
						let users = r.users || {};
						let orders = r.orders || {};
						r.logs.selected.forEach(t => {
							this.logs.push(this.normalizeLog(t, users, orders));
						});
						this.logsTotal = Number(r.logs.selected_num || 0);
					}
					if(callback) { callback(true); }
				} else {
					this.notificationStore.showNotification('generic-fail');
					if(callback) { callback(false, r ? r.details : null); }
				}
			});

		},
		normalizeLog(log, users, orders) {
			log.date = getLocalDateFromServer(log.date);
			log.type_string = this.getString(log.type);
			if(log.order_id && orders[log.order_id]) {
				log.order_number = orders[log.order_id];
				if (log.order_number < 10) {
					log.order_number = "00" + log.order_number;
				} else if (log.order_number < 100) {
					log.order_number = "0" + log.order_number;
				}
				log.order_number = "#" + log.order_number;
			} else {
				log.order_number = "-";
			}
			if(log.user_id && users[log.user_id]) {
				log.user_name = users[log.user_id];
			} else {
				log.user_name = "-";
			}
			log.variation = Number(log.variation || 0);
			log.stock = Number(log.stock || 0);
			return log;
		},
	}
}
</script>

<style scoped lang="scss">

</style>